import React from 'react';
import styled from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
`;

const Container = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  max-width: 900px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

const Title = styled.h1`
  margin: 0 0 12px 0;
  font-size: 32px;
  font-weight: 700;
  color: #24292f;
  text-align: center;
`;

const Subtitle = styled.p`
  margin: 0 0 32px 0;
  font-size: 16px;
  color: #586069;
  text-align: center;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

const TemplateCard = styled.div`
  padding: 24px;
  border: 2px solid #e1e4e8;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    border-color: #667eea;
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(102, 126, 234, 0.2);
  }
`;

const TemplateIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
`;

const TemplateName = styled.h3`
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: 600;
  color: #24292f;
`;

const TemplateDesc = styled.p`
  margin: 0;
  font-size: 14px;
  color: #586069;
  line-height: 1.5;
`;

function TemplateSelector({ onSelect }) {
  const templates = [
    {
      id: 'users-crud',
      icon: '👥',
      name: 'User Management API',
      description: 'Complete CRUD operations for user management with authentication, profiles, and permissions.'
    },
    {
      id: 'payments',
      icon: '💳',
      name: 'Payment System API',
      description: 'Payment processing with transactions, refunds, webhooks, and payment method management.'
    },
    {
      id: 'parcel-tracking',
      icon: '📦',
      name: 'Parcel Tracking API',
      description: 'Track shipments, get delivery status, manage tracking numbers, and location updates.'
    },
    {
      id: 'scratch',
      icon: '✨',
      name: 'Start from Scratch',
      description: 'Begin with a minimal OpenAPI 3.0 template and build your API specification from the ground up.'
    }
  ];

  return (
    <Overlay>
      <Container>
        <Title>Choose a Template</Title>
        <Subtitle>Start with a pre-built API template or create your own from scratch</Subtitle>
        <Grid>
          {templates.map(template => (
            <TemplateCard key={template.id} onClick={() => onSelect(template.id)}>
              <TemplateIcon>{template.icon}</TemplateIcon>
              <TemplateName>{template.name}</TemplateName>
              <TemplateDesc>{template.description}</TemplateDesc>
            </TemplateCard>
          ))}
        </Grid>
      </Container>
    </Overlay>
  );
}

export default TemplateSelector;
